import React from 'react';
import DatePicker from 'react-datepicker';

import "react-datepicker/dist/react-datepicker.css";
import './Calendar.css';
import DayPreviewModal from '../DayPreviewModal/DayPreviewModal';
let moment = require('moment');

class Calendar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            stations: null,
            selectedDate: moment(),

            modalOpen: false
        }

        this.onChangeDate = this.onChangeDate.bind(this);
        this.filterDates = this.filterDates.bind(this);
        this.onOutsideChange = this.onOutsideChange.bind(this);
    }

    componentDidMount() {
        if (this.props.stationData !== null) {
            let day = Number(this.props.selectedDate.format('D'));
            this.setState({
                stations: this.props.stationData[day],
            });
            this.addFillerData(this.props.stationData);

        } else {
            this.setState({
                stations: null,
            })
        }
        //add title of location in header of calendar
        this.addLocationTitle();
        window.addEventListener('resize', this.togglePercentLabels);
    }

    componentDidUpdate() {
        // if (this.props.modalOpen == false)
        this.addFillerData(this.props.stationData);
    }

    togglePercentLabels = () => {
        //find all nodes that have "% Full text" or just "%" text
        let datesArray = Array.from(document.getElementsByClassName('percent-filled'));
        if (datesArray === undefined || datesArray === null || datesArray.length === 0) return;
        // console.log("datesArray: ", datesArray);
        //modify each "1" index element
        datesArray.forEach(date => {
            // console.log(date.childNodes[1].textContent)
            if (date.childNodes[1].textContent.includes(" Full") && window.innerWidth < 650) {
                // console.log("REMOVE IT!!!!")
                date.childNodes[1].textContent = date.childNodes[1].textContent.replace(" Full", "\nFull");
            } else if ((date.childNodes[1].textContent.includes("\nFull")) && window.innerWidth >= 650) {
                // console.log("ADD IT")
                // date.childNodes[1].textContent += " Full";
                date.childNodes[1].textContent = date.childNodes[1].textContent.replace("\nFull", " Full");
            }
        })
    }

    onCloseModal = () => {
        this.setState({
            modalOpen: false
        });
    }

    addLocationTitle = () => {
        let titleNode = document.createElement('div');
        titleNode.textContent = "Ctrl V - " + this.props.locationName;
        titleNode.className += ' location-title';

        let subHeaderNode = Array.from(document.getElementsByClassName('react-datepicker__current-month'));
        subHeaderNode = subHeaderNode[0];
        subHeaderNode.parentNode.insertBefore(titleNode, subHeaderNode);
    }

    openModal = () => {
        this.setState({
            modalOpen: true,
        });
    }

    onChangeDate(date) {
        // console.log('jsDate: ', date);
        //let selectedMonth = Number(moment(date).format('M'));
        let selectedDay = Number(moment(date).format('D'));

        this.setState({
            selectedDate: moment(date),
            stations: this.props.stationData[selectedDay]
        })
        this.openModal();
    }

    filterDates = (date) => {
        const selectedDay = moment(date);
        let selectedDay_number = Number(selectedDay.format('D'));
        if (this.props.stationData == null || this.props.stationData[selectedDay_number] === undefined) return false;

        // console.log("STATION DATA TO COMPARE WITH", this.props.stationData);

        return moment(this.props.stationData[selectedDay_number][0].time).isSame(selectedDay, 'day');
    }

    onOutsideChange(event) {
        // console.log("THE CHANGE: ", event);
        //get the new data
        //let newDate = moment(event).format('YYYY-MM-DD');
        // console.log("new date: ", newDate);
        this.props.handleNewData(moment(event));
        // console.log("passed through here");
        // this.addFillerData(this.props.stationData);
    }

    addFillerData = (stationData) => {
        //find all DOM nodes of days, filter ones that are "real" days, apend a label inside them, add another class to easily find them later
        let days = Array.from(document.getElementsByClassName('react-datepicker__day'));
        let insideDays = days.filter(day => {
            return !day.classList.contains('react-datepicker__day--disabled') && !day.classList.contains('percent-filled')
        });
        // puts insideDays;

        const isSmallMobile = window.innerWidth < 650;

        //do something with this list
        insideDays.forEach(day => {
            if (day.textContent.length > 2) {
                return;
            }
            let para = document.createElement("P");
            let percentFilled = this.calculatePercentFilled(stationData[day.textContent], day.textContent);

            let text = percentFilled + ((isSmallMobile) ? `%\nFull` : "% Full");
            if (percentFilled < 50) text = ``;

            let textNode = document.createTextNode(text);
            para.appendChild(textNode);
            day.appendChild(para);

            day.className += " percent-filled";
            if (percentFilled === 100) {
                day.className += " day-full";
            } else if (percentFilled >= 75) {
                day.className += " day-almost-full";
            } else {
                day.className += " day-empty";
            }
        });
    }

    calculatePercentFilled = (day, date) => {
        let totalBooked = 0, totalAvailable = 0;
        day.forEach(time_slot => {
            const dateObj = new Date(time_slot.time);
            if (dateObj.getDate() === Number(date) || day.display_day_before === true) {
                totalBooked += time_slot.offered_quantity - time_slot.available_quantity
                totalAvailable += time_slot.offered_quantity
            }
        });
        return Math.round(totalBooked / totalAvailable * 100);
    }


    render() {

        // let dateRange = this.props.dates[this.state.data.format("MM")]
        // console.log("CALENDAR STATE: ", this.state);
        // this.addFillerData(this.props.stationData);

        return (
            <div className="calendar-container">
                <DatePicker
                    inline
                    onChange={this.onChangeDate}
                    shouldCloseOnSelect={false}
                    filterDate={this.filterDates}
                    onMonthChange={this.onOutsideChange}
                    onYearChange={this.onOutsideChange}
                />
                <DayPreviewModal
                    isOpen={this.state.modalOpen}
                    handleClose={this.onCloseModal}
                    date={this.state.selectedDate}
                    stationData={this.props.stationData}
                    locationID={this.props.locationID}
                    locationName={this.props.locationName}
                />
            </div>
        );
    }
}

export default Calendar;
